import { Component, Input, Output, EventEmitter } from '@angular/core';

import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'contextual-action',
  templateUrl: 'contextual-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ContextualActionComponent {

  @Input() selectedRows: Array<{}> = [];
  @Input() allSelected: boolean = false;
  @Input() selectedRowsSize: number;

  @Output() actionSelected = new EventEmitter();

  constructor(
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get selectedRowsSizeText(): number|string {
    if (this.allSelected) {
      return `about ${this.selectedRowsSize}`;
    } else {
      return this.selectedRowsSize;
    }
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onSelectedChange(action: any) {
    this.actionSelected.emit(action);
  }

  onDownloadExportClick() {
    console.log('Download export: ', this.selectedRows);
  }

  onViewExportClick() {
    console.log('View export: ', this.selectedRows);
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public hasPermission(allow: Array<string>|string, requireAll: boolean = false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }
}
